import request from '@/utils/request';
import { ApiResponse } from '@/utils/request/interceptors';
import { SubAccountListData } from '@/types/user';

export interface UserDetailData {
  rows: Array<any>;
}

// 修改密码请求参数
export interface UpdatePasswordParams {
  password: string;
  rep_password: string;
}

// 修改店铺密码请求参数
export interface UpdateShopPasswordParams {
  cid: number;
  country: string;
  password?: string;
  email_password?: string;
}

// 保存费用设置请求参数
export interface SaveFeeParams {
  air_fee: number;
  air_time: number;
  cid: number;
  exchange: number;
  id?: number;
  shipping_fee: number;
  shipping_time: number;
  volume_ratio: number;
}

// 获取费用详情请求参数
export interface GetFeeDetailParams {
  cid: number;
  country: string;
}

// 费用详情响应数据
export interface FeeDetailData {
  air_fee: number;
  air_time: number;
  cid: number;
  exchange: number;
  id: number;
  shipping_fee: number;
  shipping_time: number;
  volume_ratio: number;
}

// 获取子账号列表
export function getSubAccountList() {
  return request
    .get<ApiResponse<SubAccountListData>>('/customer/sub_list')
    .then((res) => res.data);
}

// 获取用户详情
export function getUserDetail(cid: number, country?: string) {
  const params = new URLSearchParams({ cid: cid.toString() });
  if (country) {
    params.append('country', country);
  }
  return request
    .get(`/customer/detail?${params.toString()}`)
    .then((res) => res.data);
}

// 修改密码
export function updatePassword(params: UpdatePasswordParams) {
  return request
    .post<ApiResponse<any>>('/customer/update_password', params)
    .then((res) => res.data);
}

// 修改店铺密码
export function updateShopPassword(params: UpdateShopPasswordParams) {
  return request
    .post<ApiResponse<any>>('/customer/new_account', params)
    .then((res) => res.data);
}

// 保存费用设置
export function saveFee(params: SaveFeeParams) {
  return request
    .post<ApiResponse<any>>('/customer/save_fee', params)
    .then((res) => res.data);
}

// 获取费用详情
export function getFeeDetail(params: GetFeeDetailParams) {
  return request
    .get<ApiResponse<FeeDetailData>>('/customer/fee_detail', { params })
    .then((res) => res.data.data);
}
